import React from "react";
import Card from "../../../../../common/element/Card";
import Table from "../../../../../common/element/Table";
import Tag from "../../../../../common/element/Tag";
import Scrollbar from "../../../../../common/element/ScrollBar";
import BtnLight from "../../../../../common/element/Buttons/btnLight";
import { GetAllOverviewSubmissionDocByProvider } from "../../../../../actions/admin-worker/GetAllOverviewSubmissionDocByProvider";
import Badge from "../../../../../common/element/Badge";
import { SpecificWorkerDocumentsDashboard } from "../../../../../actions/worker-portal/DashboardApis";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
const Documents = () => {
  const { id } = useParams();
  const { Tr, Th, Td, THead, TBody } = Table;
  const dispatch = useDispatch();
  const navigate=useNavigate()
  const loginData = JSON.parse(localStorage.getItem("LoginUserData")); 

//   const { SpecificWorkerData } = useSelector((state) => state);
  const [clientData, SetclientData] = useState([]);
  useEffect(() => {
    dispatch(
      SpecificWorkerDocumentsDashboard({
        individual_id: loginData?.userName?.individual_id
      })
    ).then((response) => {
      if (response.success) {
        SetclientData(response.data);
      }
    });
  }, []);
  return (
    <Card className="py-6 border border-gray-200 rounded-xl dark-shadow">
      <div className="px-6">
        <div className="card-header flex justify-between border-b border-gray-200 pb-5 mb-3">
          <div className="flex items-center">
            <span className="mr-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M9 16L11 18L15.5 13.5M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <p></p>
            <div className="flex flex-col">
              <span className="text-gray-900 text-base font-semibold">
                Documents
              </span>
              <p className="text-gray-600">Action required </p>
            </div>
          </div>
          <BtnLight className="w-20 h-9" onClick={() => navigate("/worker/documents")}>
            View All
              </BtnLight>
          
        </div>
      </div>

      <div className="max-h-[345px] overflow-y-auto cstm-scrollbar">
        <div>
          <div className="px-6">
            <div className="overflow-hidden border rounded-lg border-gray-200">
              <Table>
                <TBody>
                  {clientData &&
                    clientData?.length > 0 &&
                    clientData?.map((item,index) => (
                      <Tr key={index} >
                          <Td>
                            <div>
                              {item?.document_name ||"-"}
                              <span className="block text-gray-600">
                                {` ${item?.document_type || "-"}`}
                              </span>
                            </div>
                          </Td>
                          <Td className="w-28">
                            {/* {item?.status == "Awaiting review" && (
                              <Tag className=" bg-gray-100 text-gray-700">
                                <svg
                                  width="12"
                                  height="13"
                                  viewBox="0 0 12 13"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6 7.191a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM9.5 7.191a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM2.5 7.191a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"
                                    stroke="#475467"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                                {item?.status}
                              </Tag>
                            )}
                            {item?.status == "Approved" && (
                              <Tag className="bg-success-100 text-success-700">
                                <svg
                                  width="12"
                                  height="13"
                                  viewBox="0 0 12 13"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="m10 3.691-5.5 5.5-2.5-2.5"
                                    stroke="#039855"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                                Approved
                              </Tag>
                            )}
                             {item?.status == "Action required" || item?.status == "Action Required" && (
                              <Tag className="bg-blue-100 text-red-800">
                                <svg
                                  width="12"
                                  height="13"
                                  viewBox="0 0 12 13"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0_1592_20677)">
                                    <path
                                      d="M6 1.81641V3.06641M6 9.69141V11.6914M2.875 6.69141H1.125M10.625 6.69141H9.875M9.22855 9.91996L8.875 9.56641M9.33211 3.3993L8.625 4.10641M2.46079 10.2306L3.875 8.81641M2.56434 3.29575L3.625 4.35641"
                                      stroke="#5786CC"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_1592_20677">
                                      <rect
                                        width="12"
                                        height="12"
                                        fill="white"
                                        transform="translate(0 0.691406)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                                {item?.status}
                              </Tag>
                            )} */}
                            {/* {item?.approval_status == "Pending" && ( */}
                              <Tag className="bg-gray-100 text-gray-700">
                                <svg
                                  width="12"
                                  height="13"
                                  viewBox="0 0 12 13"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0_1592_20677)">
                                    <path
                                      d="M6 1.81641V3.06641M6 9.69141V11.6914M2.875 6.69141H1.125M10.625 6.69141H9.875M9.22855 9.91996L8.875 9.56641M9.33211 3.3993L8.625 4.10641M2.46079 10.2306L3.875 8.81641M2.56434 3.29575L3.625 4.35641"
                                      stroke="#5786CC"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_1592_20677">
                                      <rect
                                        width="12"
                                        height="12"
                                        fill="white"
                                        transform="translate(0 0.691406)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                                Pending Upload
                              </Tag>
                            {/* )} */}
                            
                          </Td>
                        </Tr>
                    ))}
                    {(clientData?.length == 0 ||
                    clientData?.length == undefined) && (
                    <Td  className="text-center p-4 block">
                      No data available
                    </Td>
                  )}
                </TBody>
              </Table>
              {/* {clientData?.length == 0 && (
                <div className="h-full w-full text-center mt-2">
                  No data available
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
export default Documents;
